var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","pb-5":""}},[_c('a',{attrs:{"href":"/dashboard"}},[_vm._v("Личный кабинет")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#00ba57"}},[_vm._v("/")]),_vm._v(" "),_c('a',{staticClass:"pt-5 pb-4",attrs:{"href":"/b2b-services"}},[_vm._v("Сервисы")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f248bf3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/services/ServicesBreadcrumbs.vue
// module id = I3ls
// module chunks = 0